import { makeAutoObservable } from "mobx";

import type { RootStore } from "@/store/RootStore";

export class LoginDialogStore {
  rootStore: RootStore;

  isOpen = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }
}
